function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M336,368.7V208c0-15.5-7.4-29.3-18.8-38.1C338.4,152.3,352,125.7,352,96c0-52.9-43.1-96-96-96s-96,43.1-96,96 c0,24.6,9.3,47,24.5,64H184c-26.5,0-48,21.5-48,48v48c0,23.7,17.3,43.5,40,47.3v65.3c-22.7,3.8-40,23.6-40,47.3v48 c0,26.5,21.5,48,48,48h144c26.5,0,48-21.5,48-48v-48C376,392.3,358.7,372.5,336,368.7z M256,32c35.3,0,64,28.7,64,64s-28.7,64-64,64 s-64-28.7-64-64S220.7,32,256,32z M344,464c0,8.8-7.2,16-16,16H184c-8.8,0-16-7.2-16-16v-48c0-8.8,7.2-16,16-16h24V272h-24 c-8.8,0-16-7.2-16-16v-48c0-8.8,7.2-16,16-16h104c8.8,0,16,7.2,16,16v192h24c8.8,0,16,7.2,16,16V464z"
});

var SvgIconSymbolInfo = function SvgIconSymbolInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconSymbolInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_symbol_info.3cfbfa0b.svg";
export { ForwardRef as ReactComponent };